import * as React from 'react';

import {motion} from 'framer-motion';

import {colors} from '../colors/colors';

import styles from './slideshow-control-dot.module.css';

type Props = {
    state: 'inactive' | 'active' | 'viewed';
    onDotClick?: () => void;
};

const ringVariants = {
    active: {
        scale: 1.5,
        stroke: colors.blue,
    },
    inactive: {
        scale: 1.5,
        stroke: colors.offWhiteDk,
    },
    viewed: {
        scale: 1.5,
        stroke: colors.blue,
    },
} as const;
const dotVariants = {
    active: {
        fill: colors.blue,
    },
    inactive: {
        fill: colors.offWhiteDk,
    },
    viewed: {
        fill: colors.blue,
    },
} as const;

/**
 * This component is used in slideshows to indicate which page the user is viewing,
 * and provides a way to jump to a different slide.
 */
export function SlideshowControlDot(props: Props) {
    const isActive = props.state === 'active';
    const canClick = Boolean(props.onDotClick);
    const styleName = isActive || !canClick ? styles['dot--noclick'] : styles.dot;

    return (
        <div onClick={isActive ? undefined : props.onDotClick} className={styleName}>
            <svg width='24px' height='24px' viewBox='0 0 14 14'>
                <motion.circle
                    variants={ringVariants}
                    animate={props.state}
                    transition={{type: 'spring', stiffness: 200, damping: 15}}
                    initial='inactive'
                    fill='none'
                    strokeWidth='0.5'
                    scale='1.5'
                    cx='7'
                    cy='7'
                    r='3.5'
                    className={styles['outer-circle']}
                />
                <motion.circle
                    variants={dotVariants}
                    animate={props.state}
                    initial='inactive'
                    stroke='none'
                    cx='7'
                    cy='7'
                    r='3.5'
                    className={styles['center-dot']}
                />
            </svg>
        </div>
    );
}
